/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterSalaryDto } from '../../models/center-salary-dto';

export interface CenterSalaryControllerFindById$Params {
  id: string;
}

export function centerSalaryControllerFindById(http: HttpClient, rootUrl: string, params: CenterSalaryControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterSalaryDto>> {
  const rb = new RequestBuilder(rootUrl, centerSalaryControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterSalaryDto>;
    })
  );
}

centerSalaryControllerFindById.PATH = '/api/center-salary/{id}';
